import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as _ from 'lodash';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';


// declare createjs object for Window
declare global {
  interface Window {
    createjs: any;
  }
}

if (environment.ENV === 'PROD') {
  enableProdMode();
}

// environment scripts
if (environment.GOOGLE_ANALYTICS_ID) {
  const script = document.createElement('script');
  script.defer = true;
  script.type = 'text/javascript';
  script.innerHTML = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
  ga('create', '${environment.GOOGLE_ANALYTICS_ID}', 'auto');`;
  document.body.appendChild(script);
}

if (environment.PENDO_ANLYTICS_ID) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = `(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
      v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
      o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
      y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
      z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
  })('${environment.PENDO_ANLYTICS_ID}');`;
  document.body.appendChild(script);
}

if (environment.STRIPE_PUBLIC_KEY) {
  const stripeLib = document.createElement('script');
  stripeLib.type = 'text/javascript';
  stripeLib.src = 'https://js.stripe.com/v2/';
  document.body.appendChild(stripeLib);
  stripeLib.onload = () => {
    const stripeInitScript = document.createElement('script');
    stripeInitScript.innerHTML = `Stripe.setPublishableKey("${environment.STRIPE_PUBLIC_KEY}");`;
    document.body.appendChild(stripeInitScript);
  };
}

if (environment.JIRA_ID) {
  const chatScript = document.createElement('script');
  chatScript.src = 'https://cdn.chat.appfire.app/app/widget-prod/get-chat.min.js';
  chatScript.defer = true;
  document.body.appendChild(chatScript);

  const chatWidget = document.createElement('chat-widget');
  chatWidget.setAttribute('jira-id', environment.JIRA_ID);
  chatWidget.setAttribute('service-desk-id', '13');
  document.body.appendChild(chatWidget);
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module[ 'hot' ]) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap()
    .catch(err => console.log(err));
}

// if (environment.VERSION) {
  const versionComment = document.createComment(`version ${environment.VERSION} 46`);
  document.body.appendChild(versionComment);
// }
